<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Número da Importação</h6>
          <vs-input class="w-full" v-model="importation.numeroImportacao" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Empresa</h6>
          <v-select name="empresa" :options="empresaOptions" v-model="importation.empresa">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Data do Pedido</h6>
          <datepicker v-model="importation.data_pedido" :format="datepickerFormat" :language="datepickerLanguage"></datepicker>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Data do Envio</h6>
          <datepicker v-model="importation.data_envio" :format="datepickerFormat" :language="datepickerLanguage"></datepicker>
        </div>
      </div>
      <br>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Peso das Caixas (KG)</h6>
          <vs-input class="w-full" v-currency="decimalWith3DigitsMask" v-model="importation.pesoCaixa" />
          <!-- v-mask -->
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-2">Modo de Envio</h6>
          <vs-input class="w-full" v-model="importation.modoEnvio" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-4">Mostrar Carimbo na Invoice</h6>
          <div class="con-s">
            <vs-switch color="success" v-model="importation.mostrarCarimbo">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <h6 class="mb-4">Mostrar apenas produtos selecionados</h6>
          <div class="con-s">
            <vs-switch color="success" v-model="showOnlySelected">
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
      </div>
      <br>
      <vue-good-table
        style="width: 100%;"
        :rows="getProducts"
        :columns="columns"
        :pagination-options="paginationOptions"
        :row-style-class="rowStyleClassFn"
        @on-row-click="selectRow"
        max-height="500px"
        styleClass="vgt-table condensed"
        :search-options="{
          enabled: true,
          skipDiacritics: true,
          placeholder: 'Procurar'
        }">
        <div slot="emptystate" class="text-center">
          Nenhum resultado encontrado
        </div>
        <template slot="table-row" slot-scope="product">
          <span class="font-medium"
            v-if="
              product.column.field == 'estoqueRegnaparts' ||
              product.column.field == 'estoqueRegnapartsReservado' ||
              product.column.field == 'estoqueRevestebem' || 
              product.column.field == 'estoqueRevestebemReservado'">
            <vs-chip style="width: 70%" color="primary">
              {{ product.formattedRow[product.column.field] }}
            </vs-chip>
          </span>
          <span class="font-medium" v-else-if="product.column.field == 'estoqueTotal'">
            <vs-chip style="width: 70%" v-if="sumStock(product.row) > 0" color="success">
              {{sumStock(product.row)}}
            </vs-chip>
            <vs-chip style="width: 70%" color="danger" v-else>
              {{sumStock(product.row)}}
            </vs-chip>
          </span>
          <div v-else-if="product.column.field == 'quantidade'">
            <vs-input class="w-3/4" type="text"
              :disabled="!product.row.selected"
              v-model="products[product.row.index].quantidade"></vs-input>
          </div>
          <span class="font-medium" v-else>
            {{ product.formattedRow[product.column.field] }}
          </span>
        </template>
        <div slot="table-actions-bottom">
          <span class="font-bold ml-4">
            Produtos selecionados: {{products.filter(el => el.selected).length}}
          </span>
        </div>
      </vue-good-table>
      <div class="flex flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { baseApiUrl } from "@/global"
import axios from 'axios'
import helpers from "@/helpers";

import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/src/locale';
export default {
  data() {
    return {
      helpers: null,
      importation: {},
      products: [],
      columns: [],
      empresaOptions: [
        { code: 1, label: 'REGNAPARTS' },
        { code: 2, label: 'REVESTEBEM' }
      ],
      datepickerLanguage: ptBR,
      datepickerFormat: 'dd MMMM yyyy',
      showOnlySelected: false,
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 25
      },
      decimalWith3DigitsMask: helpers.maskOptions.decimalWith3Digits
    }
  },
  components: {
    Datepicker
  },
  computed: {
    getProducts() {
      const products = this.products

      if (this.showOnlySelected)
        return products.filter(el => el.selected)

      return products
    },
  },
  methods: {
    async loadProducts() {
      try {
        this.$vs.loading();
        const response = await axios.post(`${baseApiUrl}/product/getAllProducts`);
        response.data.forEach((product, index) => {
          product.selected = false
          product.quantidade = ''
          product.index = index
        })
        this.products = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    sumStock(product) {
      product.estoqueTotal = product.estoqueRegnaparts +
        product.estoqueRevestebem +
        product.estoqueRegnapartsReservado +
        product.estoqueRevestebemReservado

      return product.estoqueTotal
    },
    rowStyleClassFn(row) {
      return row.selected ? 'bg-selected' : ''
    },
    selectRow(params) {
      const targetIsInput = params.event.target.tagName.toLowerCase() == 'input'
      const product = this.products[params.row.index]
      if (targetIsInput && product.selected) return
      product.selected = product.selected ? false : true
    },
    sortNumbers(x, y) {
      return (x < y ? -1 : (x > y ? 1 : 0));
    },
    async submitData() {
      const formData = {
        criado_por: this.$store.state.user.idUser,
        data_envio: this.importation.data_envio,
        data_pedido: this.importation.data_pedido,
        fk_idEmpresa: this.importation.empresa.code,
        lote: `LT-P${this.importation.numeroImportacao}`,
        modoEnvio: this.importation.modoEnvio,
        mostrarCarimbo: this.importation.mostrarCarimbo,
        numeroImportacao: this.importation.numeroImportacao,
        pesoCaixa: this.$parseCurrency(this.importation.pesoCaixa, this.decimalWith3DigitsMask)
      }
      
      const products = this.products
      const selectedProducts = products.filter(el => el.selected)
      formData.products = selectedProducts.map(el => {
        return {
          codigoProduto: el.codigo,
          quantidade: el.quantidade
        }
      })

      try {
        this.$vs.loading()
        await axios.post(`${baseApiUrl}/importation`, formData)
        this.$router.push({ name: 'importation-list' })
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar: " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close()
      }
    },
    formatValues() {
      const products = this.products
      const helpers = this.helpers
      for (let product of products) {
        product.precoAnterior = helpers.moneyHelper.formatNumberToCurrency(product.precoAnterior)
        product.precoMinimo = helpers.moneyHelper.formatNumberToCurrency(product.precoMinimo)
      }
    },
    mountTable() {
      this.columns = [{
          label: 'Código',
          field: 'codigo',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Desc. PT-BR',
          field: 'descricaoPTBR',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Desc. EN',
          field: 'descricaoEN',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Marca',
          field: 'marca',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Modelo',
          field: 'modelo',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Fornecedor',
          field: 'fornecedor',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Peso Liq.',
          field: 'pesoLiquido',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Preço Ant.',
          field: 'precoAnterior',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Preço Atual',
          field: 'precoAtual',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Preço Min.',
          field: 'precoMinimo',
          tdClass: 'vertical-middle',
        },
        {
          label: 'Estoq. Regna.',
          field: 'estoqueRegnaparts',
          sortFn: this.sortNumbers,
          tdClass: 'vertical-middle',
        },
        {
          label: 'Estoq. Rev.',
          field: 'estoqueRevestebem',
          sortFn: this.sortNumbers,
          tdClass: 'vertical-middle',
        },
        {
          label: 'Reserv. Regna.',
          field: 'estoqueRegnapartsReservado',
          sortFn: this.sortNumbers,
          tdClass: 'vertical-middle',
        },
        {
          label: 'Reserv. Rev.',
          field: 'estoqueRevestebemReservado',
          sortFn: this.sortNumbers,
          tdClass: 'vertical-middle',
        },
        {
          label: 'Estoq. Total',
          field: 'estoqueTotal',
          sortFn: this.sortNumbers,
          tdClass: 'vertical-middle',
        },
        {
          label: 'Quantidade',
          field: 'quantidade',
          tdClass: 'vertical-middle',
          width: '100px'
        },
      ]
    }
  },
  async created() {
    this.helpers = helpers
    const payload = {
      loading: this.$vs.loading
    }
    await this.loadProducts()
    this.mountTable()
  }
}

</script>

<style>
table.vgt-table {
  font-size: 0.98rem;
}

.vgt-table {
  overflow-y: auto;
  height: 100px;
}

.vgt-table th {
  position: sticky;
  top: -1px;
  z-index: 10;
  box-shadow: inset 0 1px 0 #dcdfe6,
    inset 0 -1px 0 #dcdfe6;
}

</style>
